import React, { Component } from 'react';
import { Route, Router } from 'react-router-dom';
import history from './history';

import { CoverLetters } from './components/CoverLetters'



class App extends Component {
  constructor(props) {
    super(props)
    console.log("constructor with props: " + Object.keys(this.props))

    this.makeRoutes = this.makeRoutes.bind(this)
  }

  makeRoutes() {
    console.log("makeRoutes with props: " + Object.keys(this.props))
    return (
      <Router history={history}>
        <div>
          <Route exact path="/" render={(props) => <CoverLetters {...props} />} />
          <Route exact path="/foo" render={(props) => <CoverLetters company="footech" {...props} />} />
        </div>
      </Router>
    )
  }

  render() {
    return (
      <div id="router">
        { this.makeRoutes() }
      </div>
    );
  }
}

export default App;
